"use client";

import { ReactNode } from "react";
import { SpacedRepetitionConfigContext } from "./spaced-repetition-config-context";

export const SpacedRepetitionConfigProvider = ({
  children,
  closestExamDate,
  lastSelectedDate,
  sessions,
  specializations,
  days,
}: {
  children: ReactNode;
  closestExamDate: DateString | null;
  lastSelectedDate?: DateString | null;
  sessions: Record<string, number>;
  specializations: Record<string, number>;
  days: ExamLearningPlanDayVM[];
}) => {
  return (
    <SpacedRepetitionConfigContext.Provider
      value={{
        closestExamDate,
        lastSelectedDate,
        days,
        sessions,
        specializations,
      }}
    >
      {children}
    </SpacedRepetitionConfigContext.Provider>
  );
};
